export class CheckAuthToken {
  public static loggedIn = true;
  public static count = 0;
}
